import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=5f4d6d0e&scoped=true&"
var script = {}
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=5f4d6d0e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4d6d0e",
  null
  
)

export default component.exports